import { AdditionalQuestions } from "@/canvas/features/FormV2/blocks/selection/ticketing-selection/Rates/RateCard/AdditionalQuestions";
import { MemberInfoBlock } from "@/canvas/features/FormV2/blocks/selection/ticketing-selection/Rates/RateCard/MemberInfo/MemberInfoBlock";
import { isMemberIdentityQuestion } from "@/canvas/features/FormV2/helpers/membershipMemberInfo";
import { QuestionOutput } from "@/common/types/trpc";

export interface MemberInfoQuestionsProps {
  participantIndexes: number[];
  questions: QuestionOutput[];
  fieldIdPrefix: string;
  isPreview?: boolean;
  isEditingQuestions?: boolean;
}

export const MemberInfoQuestions = ({
  participantIndexes,
  questions,
  fieldIdPrefix,
  isPreview,
  isEditingQuestions,
}: MemberInfoQuestionsProps) => {
  const collectsMemberIdentity = questions.some(isMemberIdentityQuestion);

  return (
    <AdditionalQuestions withDividers={participantIndexes.length > 1} isPreview={isPreview}>
      {participantIndexes.map((participantIndex, memberIndex) => (
        <MemberInfoBlock
          key={memberIndex}
          participantIndex={participantIndex}
          memberNumber={memberIndex + 1}
          memberCount={participantIndexes.length}
          questions={questions}
          offersBuyerChoice={collectsMemberIdentity && memberIndex === 0}
          isForBuyerDefault={collectsMemberIdentity ? memberIndex === 0 : undefined}
          fieldIdPrefix={fieldIdPrefix}
          isEditingQuestions={isEditingQuestions}
        />
      ))}
    </AdditionalQuestions>
  );
};
